<div [innerHTML]="componentData.content"></div>
